import { render, staticRenderFns } from "./TasksSidebar.vue?vue&type=template&id=2dd1ee9a&scoped=true&"
import script from "./TasksSidebar.vue?vue&type=script&lang=js&"
export * from "./TasksSidebar.vue?vue&type=script&lang=js&"
import style0 from "./TasksSidebar.vue?vue&type=style&index=0&id=2dd1ee9a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd1ee9a",
  null
  
)

export default component.exports